[
  {
    "code": "en",
    "name": "English",
    "nativeName": "English",
    "locale": "en-US",
    "direction": "ltr"
  },
  {
    "code": "ar",
    "name": "Arabic",
    "nativeName": "العربية",
    "locale": "ar",
    "direction": "rtl"
  },
  {
    "code": "es",
    "name": "Spanish",
    "nativeName": "Español",
    "locale": "es",
    "direction": "ltr"
  },
  {
    "code": "it",
    "name": "Italian",
    "nativeName": "Italiano",
    "locale": "it",
    "direction": "ltr"
  },
  {
    "code": "fr",
    "name": "French",
    "nativeName": "Français",
    "locale": "fr",
    "direction": "ltr"
  },
  {
    "code": "de",
    "name": "German",
    "nativeName": "Deutsch",
    "locale": "de",
    "direction": "ltr"
  },
  {
    "code": "hi",
    "name": "Hindi",
    "nativeName": "हिन्दी",
    "locale": "hi",
    "direction": "ltr"
  },
  {
    "code": "zh-Hans",
    "name": "Mandarin Chinese",
    "nativeName": "简体中文",
    "locale": "zh-Hans",
    "direction": "ltr"
  },
  {
    "code": "ru",
    "name": "Russian",
    "nativeName": "Русский",
    "locale": "ru",
    "direction": "ltr"
  },
  {
    "code": "km",
    "name": "Khmer",
    "nativeName": "ភាសាខ្មែរ",
    "locale": "km",
    "direction": "ltr"
  }
]